import React, { useEffect, useState } from 'react';
import '../../../styles/Admin/admin_alumniDetail.css';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { displaySnackbar, YesNoSelector } from '../../../utilities';
import { BASE_URL } from '../../../settings';

export default function Admin_EventDetail({ event, fetchEvents }) {
    const [fetchedEvent, setFetchedEvent] = useState(event);
    const navigate = useNavigate();
    let subscribersList = [];
    if (fetchedEvent?.subscribersList) subscribersList = JSON.parse(fetchedEvent?.subscribersList);

    useEffect(() => {
        // 👇️ apply a class to main top nav bar to hide it
        let mainNavBar = document.querySelector('._3drDv.MainNavBar');
        if (mainNavBar) mainNavBar.style.display = 'none';

        window.scrollTo({ top: 0, behavior: 'smooth' });

        let pathname = location.pathname.split('/');
        let id = pathname[pathname.length - 1];

        fetch(`${BASE_URL}/events/read`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id }),
        })
            .then(async (result) => {
                let response = await result.json();
                let the_events = response?.event;
                setFetchedEvent(the_events);
            })
            .catch((error) => {
                console.log(error?.message, '\n', error);
            });
    }, []);

    // 👇️ handler to delete an event
    const deleteEvent = (id) => {
        YesNoSelector('Are you sure you want to delete this announcement?', (reply) => {
            if (reply === 'yes') {
                fetch(`${BASE_URL}/events/remove`, {
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id }),
                })
                    .then(async (result) => {
                        let response = await result?.json();
                        if (response?.msg === null) {
                            displaySnackbar(response?.errorMsg, true, 'Ok', () => {});
                        } else {
                            console.log(response);
                            displaySnackbar(response?.msg, false, 'Ok', () => {});
                            setTimeout(() => {
                                fetchEvents();
                                navigate('/admin.console/events');
                            }, 1000);
                        }
                    })
                    .catch((error) => {
                        if (error?.message == 'Failed to fetch') {
                            displaySnackbar('Could not reach the servers', true, 'Ok', () => {});
                        } else {
                            displaySnackbar('Some error occurred!', true, 'Ok', () => {});
                            console.log('the error:', error);
                        }
                    });
            }
        });
    };

    return (
        <div className='alumni-detail'>
            {/* go back button */}
            <button onClick={() => navigate('/admin.console/events/')}>👈️ Go Back</button>

            {/* header bar */}
            <div className='alumni-detail-header-bar'>
                <div className='left'>
                    <h1>Event Detail</h1>
                </div>
                <div className='right'>
                    {new Date().getTime() > new Date(fetchedEvent?.endDate).getTime() && (
                        <span id='event-state'>
                            {new Date().getTime() > new Date(fetchedEvent?.endDate).getTime() &&
                                'event is overdue'}
                        </span>
                    )}
                </div>
            </div>

            {/* alumni content */}
            <div className='alumni-detail-main-content'>
                <div className='details'>
                    <span className='details-sub-header'>Event Information</span>

                    <div className='details-content-item'>
                        <span className='title'>Actions</span>
                        <button
                            style={{ backgroundColor: 'orangered' }}
                            onClick={() => deleteEvent(fetchedEvent?.uuid)}
                        >
                            Delete this event
                        </button>
                        <button
                            style={{ backgroundColor: 'green' }}
                            onClick={() =>
                                navigate(`/admin.console/events/edit/${fetchedEvent?.uuid}`)
                            }
                        >
                            Edit this event
                        </button>
                    </div>

                    <div className='details-content-item'>
                        <span className='title'>Details</span>
                        {fetchedEvent?.details?.length > 0 ? (
                            <p className='text about'>{fetchedEvent?.details}</p>
                        ) : (
                            <p className='empty-text'>...</p>
                        )}
                    </div>

                    <div className='details-content-items'>
                        <div className='details-content-item'>
                            <span className='title'>id</span>
                            {fetchedEvent?.id > 0 ? (
                                <p className='text'>{fetchedEvent?.id}</p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div className='details-content-item'>
                            <span className='title'>user id (uuid)</span>
                            {fetchedEvent?.uuid?.length > 0 ? (
                                <p className='text'>{fetchedEvent?.uuid}</p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div className='details-content-item'>
                            <span className='title'>Name</span>
                            {fetchedEvent?.name?.length > 0 ? (
                                <p className='text'>{fetchedEvent?.name}</p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div className='details-content-item'>
                            <span className='title'>Color</span>
                            {fetchedEvent?.color?.length > 0 ? (
                                <p
                                    className='text'
                                    style={{
                                        backgroundColor: fetchedEvent?.color,
                                        color: '#eee',
                                        borderRadius: '.5rem',
                                        padding: '.5rem',
                                    }}
                                >
                                    {fetchedEvent?.color}
                                </p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div className='details-content-item'>
                            <span className='title'>Start date</span>
                            {fetchedEvent?.startDate?.length > 0 ? (
                                <p className='text'>
                                    {moment(new Date(fetchedEvent?.startDate)).calendar()}
                                </p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div className='details-content-item'>
                            <span className='title'>End Date</span>
                            {fetchedEvent?.endDate?.length > 0 ? (
                                <p className='text'>
                                    {moment(new Date(fetchedEvent?.endDate)).calendar()}
                                </p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div className='details-content-item'>
                            <span className='title'>priority</span>
                            {fetchedEvent?.priority?.length > 0 ? (
                                <p className='text'>{fetchedEvent?.priority}</p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div className='details-content-item'>
                            <span className='title'>Subscribers Count</span>
                            {fetchedEvent?.subscribers ? (
                                <p className='text'>{fetchedEvent?.subscribers}</p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div className='details-content-item'>
                            <span className='title'>Posted on</span>
                            {fetchedEvent?.createdAt?.length > 0 ? (
                                <p className='text'>
                                    {moment(new Date(fetchedEvent?.createdAt)).calendar()}
                                </p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div className='details-content-item'>
                            <span className='title'>Last updated on</span>
                            {fetchedEvent?.updatedAt?.length > 0 ? (
                                <p className='text'>
                                    {moment(new Date(fetchedEvent?.updatedAt)).calendar()}
                                </p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>
                    </div>

                    <div className='details-content-item'>
                        {console.log('subscribersList:', subscribersList)}
                        <span className='title'>Subscibers List</span>
                        {subscribersList &&
                        Array.isArray(subscribersList) &&
                        subscribersList?.length > 0 ? (
                            <ul className='qualifications-list events'>
                                {Array.isArray(subscribersList) &&
                                    subscribersList?.map((item, index) => (
                                        <div
                                            className='event-subscriber-item'
                                            key={`${item?.uuid}-#${index}`}
                                            onClick={() =>
                                                navigate(
                                                    `/alumni/classes/${item?.classYear}/${item?.uuid}`
                                                )
                                            }
                                        >
                                            <div className='event-subscribers-avatar-container'>
                                                <img
                                                    src={
                                                        item?.avatar
                                                            ? `${BASE_URL}/alumni/uploads/get-profile-pic/${item?.avatar}`
                                                            : require('../../../images/profile-pictures/face1.jpg')
                                                    }
                                                    alt='event-subscriber-avatar'
                                                />
                                            </div>

                                            <div className='right'>
                                                <li className='qualifications-list-item'>
                                                    {item?.firstName} {item?.lastName}
                                                </li>

                                                <li className='qualifications-list-item'>
                                                    @{item?.username || `item-not-fount`}~
                                                    {item?.email || `item-not-fount`}
                                                </li>
                                            </div>
                                        </div>
                                    ))}
                            </ul>
                        ) : (
                            <p className='empty-text'>...</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
